import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Plus, Save, Send } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface QuickMessage {
  id: number;
  title: string;
  message: string;
}

const QuickMessages = () => {
  const [messages, setMessages] = useState<QuickMessage[]>([]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const { toast } = useToast();

  // Load messages from localStorage when component mounts
  useEffect(() => {
    const savedMessages = localStorage.getItem("quickMessages");
    if (savedMessages) {
      try {
        setMessages(JSON.parse(savedMessages));
      } catch (error) {
        console.error("Error loading messages:", error);
      }
    }
  }, []);

  // Save messages to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("quickMessages", JSON.stringify(messages));
  }, [messages]);

  const handleSave = () => {
    if (!title || !message) {
      toast({
        title: "Erro",
        description: "Preencha todos os campos",
        variant: "destructive",
      });
      return;
    }

    const newMessage: QuickMessage = {
      id: Date.now(),
      title,
      message,
    };

    setMessages([...messages, newMessage]);
    setTitle("");
    setMessage("");

    toast({
      title: "Sucesso",
      description: "Mensagem rápida salva com sucesso!",
    });
  };

  const handleSend = (msg: QuickMessage) => {
    // Aqui você implementaria a lógica de envio para o WhatsApp
    toast({
      title: "Enviando mensagem",
      description: "Mensagem sendo enviada para o WhatsApp...",
    });
  };

  return (
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <h2 className="text-3xl font-bold">Mensagens Rápidas</h2>
          <Button onClick={() => setMessage("")}>
            <Plus className="mr-2" /> Nova Mensagem
          </Button>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Nova Mensagem Rápida</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <Input
              placeholder="Título da mensagem"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <Textarea
              placeholder="Digite sua mensagem..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
            />
            <Button onClick={handleSave} className="w-full">
              <Save className="mr-2" /> Salvar Mensagem
            </Button>
          </CardContent>
        </Card>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {messages.map((msg) => (
            <Card key={msg.id}>
              <CardHeader>
                <CardTitle>{msg.title}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-sm text-gray-600">{msg.message}</p>
                <Button onClick={() => handleSend(msg)} className="w-full">
                  <Send className="mr-2" /> Enviar
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
  );
};

export default QuickMessages;